import styled from 'styled-components';
import { useTranslation } from 'modules/domains/list';
import { spacing, link, body1 } from 'ui/theme';
import { EmptyState } from 'ui/emptyState';
import { ListsEmptyState } from 'ui/illustrations';
import { useListsContext } from '../contexts';
import { SEGMENTATION_URL } from '../constants';

const Wrapper = styled.div`
  width: 100%;
  min-height: ${spacing.x24};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SubtitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Link = styled.a`
  ${body1}
  ${link}
`;

export const ListsNoResultsPlaceholder = () => {
  const { lists, isLoading, listFolders } = useListsContext();
  const { t } = useTranslation();
  const hasNoListsOrListFolders = lists.length === 0 && listFolders.length === 0 && !isLoading;

  return (
    hasNoListsOrListFolders && (
      <Wrapper>
        <EmptyState
          Illustration={ListsEmptyState}
          title={t('indexPage.table.emptyState.header')}
          subtitle={
            <SubtitleWrapper>
              <span>{t('indexPage.table.emptyState.subtitle')}</span>
              <Link target="_blank" href={SEGMENTATION_URL}>
                {t('indexPage.table.emptyState.link')}
              </Link>
            </SubtitleWrapper>
          }
        />
      </Wrapper>
    )
  );
};
